import React, {useState, useEffect} from "react";
import Crayon from "../iconComponents/Crayon";
import {connect, useSelector} from "react-redux";
import {updateUserCompanyRole} from "../../actions/people";
import IconIndicator from "../iconComponents/Indicator";
import Info from "../common/Info";
import {useSubmitGuard} from "../common/Helpers";

export function PersonDetails(props) {

const auth = useSelector((state) => state.auth);

const [crayonHovered, setCrayonHovered] = useState(false);
const [editorActive, setEditorActive] = useState(props.tab === "by_request" ? true : false);
const {isSubmitting, guardedSubmit} = useSubmitGuard();

const handleClickCrayon = (e) => {
    setEditorActive(true);
    setCrayonHovered(false);
}

const handleToggleRoles = (e) => {
    if (e.target.id === "company-admin") {
        // if giving co admin permissions and user does NOT have creator permissions, give creator permissions as well as co admin permissions
        // otherwise, just toggle co admin permissions
        if (!props.roleCa && !props.roleCreator) {
            props.setRoleCreator(true);
        }
        props.setRoleCa(!props.roleCa);
        // toggle creator permissions independantly (toggle will be true & disabled if co admin permissions exist)
    } else {
        props.setRoleCreator(!props.roleCreator); 
    }
}

const handleSubmit = guardedSubmit((e) => {
    e.preventDefault();
    props.updateUserCompanyRole(props.person.user_id, {"Company Admin": props.roleCa, Creator: props.roleCreator});
    setEditorActive(false);
});

const handleCancel = () => {
    setEditorActive(false);
    // reset checkboxes to match exististing user permissions
    props.setRoleCa(props.person.croles["Company Admin"] ? props.person.croles["Company Admin"] : false);
    props.setRoleCreator(props.person.croles.Creator ? props.person.croles.Creator : false);
}

useEffect(() => {
    // when section is closed, reset state
    if (!props.open) {
        setEditorActive(false);
        // reset checkboxes to match exististing user permissions
        props.setRoleCa(props.person.croles["Company Admin"] ? props.person.croles["Company Admin"] : false);
        props.setRoleCreator(props.person.croles.Creator ? props.person.croles.Creator : false);
    }
}, [props.open]);

const CAInfo = () => <Info heading="Super Users" >can admit new users into the company, and give or revoke user permissions</Info>
const EditorInfo = () => <Info heading="Editors" >can create projects & contracts on behalf of the company, and represent the company on contracts (act as Vendor Rep or Purchaser Rep)</Info>

const permissionsEditor = (
    <form onSubmit={(e) => handleSubmit(e)}>	
        <div className="checkbox-wrapper " >
            <input 
                className="typical-checkbox"
                type="checkbox"
                id="company-admin"
                name="company-admin"
                checked={props.roleCa}
                onChange={(e) => handleToggleRoles(e)}
            />
            <label htmlFor="company-admin" className="content1 light-black multiline" >Super user </label>
            <CAInfo />
        </div>
        <div className="checkbox-wrapper " >
            <input 
                className="typical-checkbox"
                type="checkbox"
                id="creator"
                name="creator"
                checked={props.roleCreator}
                onChange={(e) => handleToggleRoles(e)}
                disabled={props.roleCreator && props.roleCa}
            />
            <label htmlFor="creator" className="content1 light-black multiline" >Editor </label>
            <EditorInfo />
        </div>

        {props.tab !== "by_request" &&
            <div className="flex-row gap-above-s">
            <button id={`savePerm-${props.userBoxId}`} type="submit" className="btn pri flex1 gap-right-xs" disabled={isSubmitting} >{isSubmitting ? "Please wait..." : "Save changes"}</button>
            <button className="btn sec flex1" disabled={isSubmitting} onClick={() => handleCancel()}>Cancel</button>
        </div>}
    </form>
)

const permissionsViewer = (
    <>
        {props.person.croles["Company Admin"] && 
            <div>
                <h4 className="content1 iblock light-black multiline" >Super User</h4>
                <CAInfo />
            </div>}
        {props.person.croles.Creator && 
            <div>
                <h4 className="content1 iblock light-black multiline" >Editor</h4>
                <EditorInfo />
            </div>}
        {(!props.person.croles["Company Admin"] && !props.person.croles.Creator) && <h4 className="content1 light multiline" >None</h4>}
    </>
)
    
    return (
        <div className="info-grid " style={props.tab === "by_project" ? {gridTemplateColumns: "repeat(3, minmax(0, 1fr))"}:{gridTemplateColumns: "repeat(4, minmax(0, 1fr))"}}>
            <div className="item lastrow firstcol">
                <h3 className="content2 heavy-grey gap-below-xxs">Contact</h3>
                <h4 className="content1 light-black multiline" >{props.person.first_name + " " + props.person.last_name} </h4>
                <h4 className="content1 light-black multiline" >{props.person.email} </h4>
                <h4 className="content1 light-black multiline" >{props.person.phone_number && props.person.phone_number} </h4>
            </div>
            {props.tab !== "by_project" &&
            <div className="item lastrow">
                <div>
                    {props.tab === "by_request" &&
                    <div className="iblock gap-right-s">
                        <IconIndicator pathClass="p-fill" height="12px" />
                    </div>}
                    <h3 className="iblock content2 heavy-grey gap-below-xxs gap-right-xs">Permissions</h3>
                    {(!editorActive && auth.user.croles["Company Admin"]) &&
                    <button 
                        id={`editPerm-${props.userBoxId}`}
                        onClick={(e) => handleClickCrayon(e)}
                        onMouseEnter={() => setCrayonHovered(true)}
                        onMouseLeave={() => setCrayonHovered(false)}
                    >
                        <Crayon className="iblock" height="13px" pathClass={crayonHovered ? "g1-fill" : "g6-fill"} />
                    </button>
                    }
                </div>
                {editorActive && auth.user.croles["Company Admin"] ? permissionsEditor : permissionsViewer}
            </div>}
            <div className="item lastrow">
                <h3 className="content2 heavy-grey gap-below-xxs"></h3>
                {/* <h4 className="content1 light-black multiline">Project Name</h4> */}
            </div>
            <div className="item lastrow">
                <h3 className="content2 heavy-grey gap-below-xxs"></h3>
                {/* <h4 className="content1 light-black multiline">Role Name</h4> */}
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {updateUserCompanyRole})(PersonDetails);

